// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html[data-v-11ae97ce],\nbody[data-v-11ae97ce],\n.v-application--wrap[data-v-11ae97ce] {\n  background: #0a0f19 !important;\n  overflow: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
